import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import "./index.css";

const personaliseBenefits = [
  "Industry-Verified Certification",
  "Lifetime Access to 3100+ More Courses",
  "Live Doubt Solving",
];

const normalBenefits = [
  "Certification starts at ₹129",
  "Lifetime Access to 3100+ More Courses",
  "Limited Doubt Solving",
];

const BottomEvenPersonaliseSection = ({
  razorpayHandler,
  onboardingData,
  handleSkip,
}) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const newLearners = useCallback(() => {
    const time = new Date();
    const hours = time.getHours();
    const minutes = time.getMinutes();
    let maxLearners =
      hours.toString() +
      (minutes <= 9 ? "0" + minutes.toString() : minutes.toString());
    console.log(maxLearners);
    return Math.max(parseInt(maxLearners) + 9, 171);
  }, []);

  return (
    <div className="bottom-linear-gradient-background rounded-2xl border border-[#1CA571] p-3 text-center md:mt-10 md:border-2">
      <h3 className="px-4 text-2xl font-semibold">
        How Do You Want To Proceed?
      </h3>
      <div className="md:hidden">
        <div
          className="mt-2 flex items-center justify-center rounded-lg bg-[#1CA571] p-2"
          onClick={() => {
            Mixpanel.track(
              Constants.Mixpanel
                .PERSONALISE_PAGE_ANALYSIS_BOTTOM_PERSONALISE_PAYMENT,
            );
            setLoading(true);
            razorpayHandler(() => setLoading(false));
          }}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              <ClipLoader color="black" size={20} />
            </div>
          ) : (
            <>
              <div>
                <p className="font-semibold">Unlock Personalised Course</p>
              </div>
              <div className="ml-3">
                <img
                  src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Arrow.png?updatedAt=1694517910311"
                  width={34}
                  height={34}
                  alt="right arrow"
                />
              </div>
            </>
          )}
        </div>
        <p className="mt-0.5 mb-2 text-xs font-medium">
          8/10 Candidates Got Hired Who Took This Course
        </p>
        <p className="font-semibold">or</p>
        <div
          className="mt-2 rounded-lg border border-[#1983D0] bg-[#0E2C4B] px-2 py-3.5"
          onClick={() => {
            Mixpanel.track(
              Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS_BOTTOM_NORMAL,
            );
            handleSkip();
          }}
        >
          <p className="font-semibold text-[#1983D0]">
            Continue To Standard Course (Free)
          </p>
        </div>
        <p className="my-0.5 text-xs font-medium">
          {" "}
          Verified certificate not included
        </p>
      </div>
      <div className="mt-6 hidden h-full justify-between md:flex">
        <div className="w-[45%]">
          <h3 className="text-xl font-semibold">Unlock Personalised Course</h3>
          <p className="mt-1 mb-5 font-semibold">
            Early Bird Discount: ₹199{" "}
            <span className="text-[#E06064] line-through">₹1199</span>
          </p>
          {personaliseBenefits?.map((item, index) => (
            <div
              key={index}
              className="mt-2 flex items-center justify-center rounded-lg bg-[#1A3A5A] py-2 px-1"
            >
              <FontAwesomeIcon icon={faCircleCheck} color="#4AAD60" />
              <p className="ml-2  text-sm font-semibold">{item}</p>
            </div>
          ))}
          <div
            className="mt-6 flex cursor-pointer items-center justify-center rounded-lg bg-[#1CA571] p-2"
            onClick={() => {
              Mixpanel.track(
                Constants.Mixpanel
                  .PERSONALISE_PAGE_ANALYSIS_BOTTOM_PERSONALISE_PAYMENT,
              );
              setLoading(true);
              razorpayHandler(() => setLoading(false));
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <ClipLoader color="black" size={20} />
              </div>
            ) : (
              <>
                <p className="font-semibold">Unlock Personalised Course</p>
                <div className="ml-3">
                  <img
                    src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Arrow.png?updatedAt=1694517910311"
                    width={34}
                    height={34}
                    alt="right arrow"
                  />
                </div>
              </>
            )}
          </div>
          <div className="mt-1 flex items-center justify-center">
            <div className="h-full w-[62px]">
              <img
                src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8604.png?updatedAt=1687502602718"
                alt="user images"
                className="h-auto w-full"
              />
            </div>
            <p className="text-xs font-medium">{newLearners()} Unlocks Today</p>
          </div>
        </div>
        <div className="h-[290px] w-[2px] bg-[#60AFFF]"></div>
        <div className="w-[45%]">
          <h3 className="text-xl font-semibold">Unlock Standard Course</h3>
          <p className="mt-1 mb-5 font-semibold">Free (3x Slower)</p>
          {normalBenefits?.map((item, index) => (
            <div
              key={index}
              className="mt-2 flex items-center justify-center rounded-lg bg-[#1A3A5A] py-2 px-1"
            >
              <FontAwesomeIcon icon={faCircleCheck} color="#4AAD60" />
              <p className="ml-2  text-sm font-semibold">{item}</p>
            </div>
          ))}
          <div
            className="mt-6 flex cursor-pointer items-center justify-center rounded-lg border-2 border-[#1983D0] bg-[#0E2C4B] py-3"
            onClick={() => {
              Mixpanel.track(
                Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS_BOTTOM_NORMAL,
              );
              handleSkip();
            }}
          >
            <p className="font-semibold text-[#1983D0]">
              Continue To Standard Course (Free)
            </p>
          </div>
          <p className="mt-2 text-xs font-medium">
            Verified certificate not included
          </p>
        </div>
      </div>
    </div>
  );
};

export default BottomEvenPersonaliseSection;
